import { phonerotheme } from '@jotta/ui/themes/phonero'
import { startApp } from '../App'

startApp(phonerotheme)
